import React from 'react';

export default [{
  name: 'typy',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Gürmük Vergisi Hesaplama
      </div>
      <div className='portfolio-item__desc'>
        Yurtdışından yapılan alışverişlerden çıkacak vergiyi hesaplar. Ürün paylaşma sayesinde kolayca toplu alım yapabilirsiniz
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-npm"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.kayafatih.net.gumrukvergihesaplama">More</a>
      </div>
    </div>
  )
}, {
  name: 'dev-landing-page',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Şifreleri Sakla
      </div>
      <div className='portfolio-item__desc'>
        Güçlü şifre üretir. Parmak izi ile giriş ile kolayca ulaşabilirsiniz. 
        Telefonun hafızasına kayıt eder internete ihtiyacı yoktur
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-html5"></i>
        <i className="fab fa-css3"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.kayafatih.net.passwordmanager">More</a>
      </div>
    </div>
  )
}, {
  name: 'react-redux-boilerplate',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Banka Hesaplarım (Beta)
      </div>
      <div className='portfolio-item__desc'>
        IBAN numaranızı ve kredi kartı numaranızı telefon hafızasına kayıt eder
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-react"></i>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.kayafatih.net.banka_hesaplarim">More</a>
      </div>
    </div>
  )
}]


// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js